import { useMemo } from "react";

export default function useMobileDetect() {
	const userAgent = typeof navigator !== "undefined" ? navigator.userAgent : "";

	const api = useMemo(() => {
		const isAndroid = /Android/i.test(userAgent);
		const isIos = /iPhone|iPad|iPod/i.test(userAgent);
		const isMobile = isAndroid || isIos || /Mobi|Mobile|Phone/i.test(userAgent);
		return {
			isAndroid: () => isAndroid,
			isIos: () => isIos,
			isMobile: () => isMobile
		};
	}, [userAgent]);

	return api;
}
